import React, { useState } from "react";
import { adminForgotPassword } from "../Apis/AdminApis";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./AdminLogin.css";

const ForgotPassword = ({ onBack, onSuccess, setPopupMessage, setPopupType, setPopupOpen }) => {
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [inputMode, setInputMode] = useState("email"); 
  const [mobileValue, setMobileValue] = useState("");
  const handleTextChange = (e) => {
  const value = e.target.value;
    setInputValue(value);
    if (value.length > 0 && /^\d+$/.test(value)) {
      setInputMode("mobile");
      setMobileValue(`+91${value}`);
    } else {
      setInputMode("email");
    }
  };

const handleMobileChange = (value) => {
  setMobileValue(value);
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    if ((inputMode === "email" && !inputValue) || (inputMode === "mobile" && !mobileValue)) {
      setPopupMessage("Please enter email or mobile number");
      setPopupType("error");
      setPopupOpen(true);
      return;
    }

    let payload;

    if (inputMode === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(inputValue)) {
        setPopupMessage("Please enter a valid email address");
        setPopupType("error");
        setPopupOpen(true);
        return;
      }
      payload = {
        otp_send_type: "email",
        email: inputValue
      };
    } else {
    const mobileNumber = mobileValue.replace(/\D/g, "");
const last10Digits = mobileNumber.slice(-10);

if (last10Digits.length !== 10) {
  setPopupMessage("Please enter a valid 10-digit mobile number");
  setPopupType("error");
  setPopupOpen(true);
  return;
}
      payload = {
        otp_send_type: "mobile",
        mobile: mobileValue
      };
    }

    setLoading(true);
    const response = await adminForgotPassword(payload);

    if (response.error) {
      setPopupMessage(response.error);
      setPopupType("error");
    } else {
      setPopupMessage(`${response.message} (${response.destination})`);
      setPopupType("success");
      onSuccess(inputMode === "email" ? inputValue : mobileValue);
    }

    setPopupOpen(true);
    setLoading(false);
  };

  return (
    <div className="login-card">
      <h2 className="otp-title">Forgot Password</h2>
      <p className="otp-subtitle">Enter your email or mobile number and we'll send you an OTP to reset your password.</p>

      <div className="input-group">
        <label>{inputMode === "email" ? "Email or Mobile:" : "Mobile Number:"}</label>
        
        {inputMode === "email" ? (
          <input
            type="text"
            value={inputValue}
            onChange={handleTextChange}
            placeholder="Enter email or mobile number"
            className="email-input"
          />
        ) : (
          <PhoneInput
            country={"in"}
            value={mobileValue}
            onChange={handleMobileChange}
            inputProps={{
              required: true,
              placeholder: "Enter 10-digit mobile number"
            }}
            containerClass="phone-input-container"
            inputClass="phone-input-field"
            buttonClass="phone-input-button"
          />
        )}
      </div>

      {inputValue && /^\d+$/.test(inputValue) && inputMode === "email" && (
        <div className="auto-detect-hint">
          💡 Detected numbers. Automatically switching to mobile mode with country code.
        </div>
      )}

      <button className="send-otp-btn" onClick={handleSubmit} disabled={loading || (!inputValue && !mobileValue)}>
        {loading ? "Sending OTP..." : "Send OTP"}
      </button>
      
      <button className="back-btns" onClick={onBack}>
        ← Back to Login
      </button>
    </div>
  );
};

export default ForgotPassword;